import React, { memo, useEffect } from 'react';
import {
    Card, CardBody, Row, Col, Button, Spinner, ButtonToolbar
} from "reactstrap";
import { MdArrowBack, 
    // MdFileUpload, MdInvertColors 
} from "react-icons/md";
import { connect } from "react-redux";
import validate from "./validate";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { renderField } from '../../../../utils/renderfield';
import renderDatePickerField from "../../../../shared/components/form/DatePicker";
import { Link } from "react-router-dom";
// import renderRadioButtonField from '../../../../shared/components/form/RadioButton';
// import ColorChooser from './ColorChooser';
// import TextField from '@material-ui/core/TextField';
// import Autocomplete from '@material-ui/lab/Autocomplete';
import FepDropdown from './FepDropdown';

const InstitutionForm = memo(({ handleSubmit, fepDomain, invalid, postInstitution, submitting, reset,
    pristine, institutionId, institution, setFepDomain, isAdminPresent }) => {

   useEffect(() => {
       if(fepDomain){
           setFepDomain(fepDomain);
       }
   }, [fepDomain])

    useEffect(() => {
        reset(); 
      }, []);

    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <div className="card__title">
                        <h5 className="bold-text">
                            <Link to="/institution" id="link-all-users">
                                <MdArrowBack size={20} /> Back to Institutions List
                            </Link>
                        </h5>
                    </div>
                    {isAdminPresent === false &&
                        <div className="wizard">
                            <div className="wizard__steps">
                                <div
                                    className="wizard__step wizard__step--active"
                                >
                                    <p>Institution Details</p>
                                </div>
                                <div
                                    className="wizard__step" 
                                >
                                    <p>Create Admin User</p>
                                </div>
                                <div
                                    className="wizard__step" 
                                >
                                    <p>Finish Setup</p>
                                </div>
                            </div>
                        </div>
                    }
                    <br />
                    {institution && institutionId && institution.loading ? (
                        <div className="text-center">
                            <div>
                                <Spinner
                                    color="success"
                                    className="my-4"
                                    style={{ width: "6rem", height: "6rem" }}
                                />
                                <h4 className="text-secondary">
                                    Fetching institution with id ({institutionId})
                                </h4>
                            </div>
                        </div>
                        ) :
                        <form className="form" onSubmit={handleSubmit}>
                            <Col lg={{ size: 8, offset: 2 }}>
                                <Row>
                                    <Col lg="10">
                                        <h4 className="form__form-group-label bold-text">
                                            {institutionId ? 'Update institution details below': 'Enter institution details in the form below'}
                                        </h4>
                                        <br />
                                        <br />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg="5">
                                        <div className="form__form-group">
                                            <span className="form__form-group-label bold-text required">Institution Name</span>
                                            <div className="form__form-group-field">
                                                <Field
                                                    id="name"
                                                    name="name"
                                                    component={renderField}
                                                    type="text"
                                                    placeholder="Enter your preferred institution name"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </Col>
                            
                                    {institution && institutionId ? '' : <Col lg="5">
                                        <div className="form__form-group">
                                            <span className="form__form-group-label bold-text required">Client Id</span>
                                            <div className="form__form-group-field">
                                                <Field
                                                    id="clientId"
                                                    name="clientId"
                                                    component={renderField}
                                                    type="text"
                                                    placeholder="Enter client Id"
                                                    required={institutionId ? false : true}
                                                />
                                            </div>
                                        </div>
                                    </Col>}
                                </Row>
                                <Row>
                                    <Col lg="10">
                                        <div className="form__form-group">
                                            <span className="form__form-group-label bold-text required">Float Card</span>
                                            <div className="form__form-group-field">
                                                <span style={{ width: '70%' }}>
                                                    <Field
                                                        id="cardPan"
                                                        name="cardPan"
                                                        component={renderField}
                                                        type="number"
                                                        placeholder="Card Number"
                                                        required={institutionId ? false : true}
                                                    />
                                                </span>
                                                &nbsp;&nbsp;
                                                <span>
                                                <Field
                                                    id='expiryDate'
                                                    name='expiryDate'
                                                    dateFormat="yy/MM"
                                                    minDate={new Date()}
                                                    component={renderDatePickerField}
                                                    placeholder="Expiry Date"
                                                    showMonthYearPicker
                                                    required={institutionId ? false : true}
                                                />
                                                </span>
                                                &nbsp;&nbsp;
                                                <span>
                                                    <Field
                                                        id="cvv"
                                                        name="cvv"
                                                        component={renderField}
                                                        type="number"
                                                        minLength={3}
                                                        maxLength={3}
                                                        placeholder="CVV"
                                                        required={institutionId ? false : true}
                                                    />
                                                </span>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg="5">
                                        <div className="form__form-group">
                                            <span className="form__form-group-label bold-text required">Pin</span>
                                            <div className="form__form-group-field">
                                                <Field
                                                    id="pin"
                                                    name="pin"
                                                    component={renderField}
                                                    type="number"
                                                    minLength={4}
                                                    maxLength={4}
                                                    placeholder="Enter four(4) digit pin"
                                                    required={institutionId ? false : true}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                               
                                    {   !institutionId ?
                                        <Col lg="5">
                                            <FepDropdown 
                                                disabled={institutionId && true}
                                                required={institutionId ? false : true} 
                                            />
                                        </Col> : ''
                                    }
                                </Row>
                                <Row>
                                    <Col lg="6">
                                        <div className="form__form-group">
                                            <span className="form__form-group-label required bold-text">Phone number</span>
                                            <small style={{ color: "blue", fontSize: "9px" }}>(e.g 08022012222)</small>
                                            <div className="form__form-group-field">
                                                <Field id="subscriberId" name="subscriberId" component={renderField} type="number" placeholder="phone number" />
                                            </div>
                                        </div>
                                    </Col> 
                                </Row>
                                <br />
                                <ButtonToolbar className="form__button-toolbar">
                                    <Button
                                        type="button"
                                        id="reset-form"
                                        onClick={reset}
                                        disabled={pristine || submitting}
                                    >
                                        Cancel
                                    </Button>
                                    <Button 
                                        color="primary" 
                                        type="submit" 
                                        id="submit-form" 
                                        disabled={pristine || submitting || invalid}
                                    >
                                        {postInstitution && postInstitution.loading ? (
                                            <span>
                                                <Spinner size="sm" color="default" />{" "}
                                            </span>
                                        ) : null}
                                            {institutionId ? 'Update' : 'Add Institution'}
                                        </Button>
                                </ButtonToolbar>
                            </Col>
                        </form>
                    }
                </CardBody>
            </Card>
        </Col>
    );
});

const selector = formValueSelector("institution_form");
export default reduxForm({
    form: "institution_form",
    validate,
    enableReinitialize: true
})(
    connect((state) => ({
        // postInstitution: state.postInstitution
        fepDomain: selector(state, 'fepCode')
    }))(InstitutionForm)
);